export default "Secret Games opened in May 2015.";